import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        origins: false
      },
      options: {
        origins: []
      },
      selected: {
        origin: '',
        allowOut: '',
        allowIn: '',
        allowPO: '',
        locationType: 'Branch'
      },
      editable: {
        origin: ''
      }
    }
  },

  methods: {

    async getOrigins (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.origin
      const allowIn = context.selected?.allowIn
      const allowOut = context.selected?.allowOut
      const fetching = context.fetching?.origins
      const options = context.options?.origins

      const hasInvalidContext = [
        selected,
        allowIn,
        allowOut,
        fetching,
        options
      ].some(nullOrUndefined)

      if (hasInvalidContext) {
        throw Error('Invalid context object')
      }

      context.fetching.origins = true
      context.selected.origin = ''

      const filters = {
        filter_text: search,
        allow_out: context.selected.allowOut,
        allow_in: context.selected.allowIn,
        allow_po: context.selected.allowPO,
        location_type: context.selected.locationType
      }

      return await SSharedList.getLocations(filters).then(
        ({ data }) => {
          context.options.origins = data.filter(
            originated => String(originated.id) !== String(this.user?.location)
          )
        }
      ).catch(() => {
        context.options.origins = []
      }).finally(() => {
        context.fetching.origins = false
      })
    },

    async searchOrigins (search, loading) {
      this.searchOriginsProvider(this, search, loading)
    },

    searchOriginsProvider: QUERY.debounce(
      ({ options, selected }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.origins, {
          keys: ['location_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search,
            allow_in: selected.allowIn,
            allow_out: selected.allowOut,
            allow_po: selected.allowPO,
            location_type: selected.locationType
          }

          SSharedList.getLocations(filters).then(
            ({ data }) => {
              options.origins = data
            }
          ).catch(() => {
            options.origins = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
